export default __webpack_public_path__ + "static/media/slide1.0e861aeb.png";